import moment from "moment";
import { useEffect } from "react";
type CalendarType = {
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  backgroundColor: string;
  fontColor: string;
  left: string;
  top: string;
  height: string;
  children?: Array<any>;
  isMulti?: boolean;
};

/** Used when milestone.graphics is missing */
const DEFAULT_GRAPHICS_BACKGROUND = "#3C406C";
const DEFAULT_GRAPHICS_FONT_COLOR = "#FFFFFF";

function resolveEventBackground(
  graphics?: { iconbg?: string } | null
): string {
  const bg = graphics?.iconbg?.trim();
  return bg || DEFAULT_GRAPHICS_BACKGROUND;
}

/** to replace with invalid date */
const MIN_EVENT_BAR_WIDTH_PX = 200;
const DATE_TBD_LABEL = "Date";

function formatMilestoneDateDisplay(raw: any): string {
  const m = moment(raw);
  return m.isValid() ? m.format("DD MMM") : DATE_TBD_LABEL;
}

/** to replace with invalid date */
function resolveLayoutDateRange(
  startRaw: any,
  endRaw: any,
  semesterAnchor: any
): { start: Date; end: Date } {
  const anchor = moment(semesterAnchor);
  const safeAnchor = anchor.isValid()
    ? anchor.clone().startOf("day")
    : moment().startOf("day");
  const s = moment(startRaw);
  const e = moment(endRaw);

  if (s.isValid() && e.isValid()) {
    if (e.isBefore(s)) {
      return { start: s.toDate(), end: s.clone().add(7, "days").toDate() };
    }
    return { start: s.toDate(), end: e.toDate() };
  }
  if (s.isValid()) {
    return { start: s.toDate(), end: s.clone().add(7, "days").toDate() };
  }
  if (e.isValid()) {
    return {
      start: e.clone().subtract(7, "days").toDate(),
      end: e.toDate(),
    };
  }
  const start = safeAnchor.clone();
  return { start: start.toDate(), end: start.clone().add(7, "days").toDate() };
}

const dateDiffWeeks = (date1S: any, date2S: any, view: "week" | "month") => {
  var date1 = new Date(date1S);
  var date2 = new Date(date2S);
  if (Number.isNaN(date1.getTime()) || Number.isNaN(date2.getTime())) {
    return NaN;
  }

  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();
  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  if (view === "month") {
    return Difference_In_Days / 31;
  }
  return Difference_In_Days / 7;
};
export const generateDates = (
  start: any,
  end: any,
  view: "week" | "month",
  lengthNumber: number,
  important: {
    add_drop_date: string;
    final_assess_date: string;
    final_recording_date: string;
  }
) => {
  var empty: string[] = [];
  if (view === "week") {
    var arrWeek, dt, de, counter;
    if (dateDiffWeeks(start, end, "week") <= lengthNumber) {
      for (
        counter = 0,
          arrWeek = [],
          dt = new Date(start),
          de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
        counter <= lengthNumber;
        counter++, dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
      ) {
        // if (
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isBetween(
        //     moment(moment(dt).format("DD MMM"), "DD MMM"),
        //     moment(moment(de).format("DD MMM"), "DD MMM")
        //   ) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        // ) {
        //   arrWeek.push({
        //     date:
        //       moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
        //     add_drop_date: true,
        //     exact_date: important.add_drop_date
        //   });
        // }
        if (
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          if (
            moment(
              moment(important.final_assess_date).format("DD MMM"),
              "DD MMM"
            ).isBetween(
              moment(moment(dt).format("DD MMM"), "DD MMM"),
              moment(moment(de).format("DD MMM"), "DD MMM"),
              null,
              '[]' // Inclusive check
            )
          ) {

            arrWeek.push({
              date:
                moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
              final_assess_date: true,
              assess_date: important.final_assess_date,
            });
          } else {
            arrWeek.push({
              date:
                moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
            });
          }
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            date:
              moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrWeek.push({
            date:
              moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
          });
        }
        // arrWeek.push(
        //   moment(dt).format('DD MMM') + '-' + moment(de).format('DD MMM'),
        // );
      }
    } else {
      for (
        arrWeek = [],
          dt = new Date(start),
          de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
      ) {
        // if (
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isBetween(
        //     moment(moment(dt).format("DD MMM"), "DD MMM"),
        //     moment(moment(de).format("DD MMM"), "DD MMM")
        //   ) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        // ) {
        //   arrWeek.push({
        //     date:
        //       moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
        //     add_drop_date: true, exact_date: important.add_drop_date
        //   });
        // }
        if (
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          if (
            moment(
              moment(important.final_assess_date).format("DD MMM"),
              "DD MMM"
            ).isBetween(
              moment(moment(dt).format("DD MMM"), "DD MMM"),
              moment(moment(de).format("DD MMM"), "DD MMM")
            )
          ) {
            arrWeek.push({
              date:
                moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
              final_assess_date: true,
              assess_date: important.final_assess_date,
            });
          } else {
            arrWeek.push({
              date:
                moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
            });
          }
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            date:
              moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrWeek.push({
            date:
              moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM"),
          });
        }
        // arrWeek.push(
        //   moment(dt).format('DD MMM') + '-' + moment(de).format('DD MMM'),
        // );
      }
    }
    return arrWeek;
  } else if (view === "month") {
    var arrMonth, dtMonth, deMonth, counter;
    if (dateDiffWeeks(start, end, "month") <= lengthNumber) {
      for (
        counter = 0,
          arrMonth = [],
          dtMonth = new Date(start),
          deMonth = getLastDayOfMonth(
            new Date(start).getFullYear(),
            new Date(start).getMonth()
          );
        counter <= lengthNumber;
        counter++,
          dtMonth = getFirstDayOfMonth(
            new Date(dtMonth).getFullYear(),
            new Date(dtMonth).getMonth() + 1
          ),
          deMonth = getLastDayOfMonth(
            new Date(deMonth).getFullYear(),
            new Date(deMonth).getMonth() + 1
          )
      ) {
        // if (
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isBetween(
        //     moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
        //     moment(moment(deMonth).format("DD MMM"), "DD MMM")
        //   ) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
        //   moment(
        //     moment(important.add_drop_date).format("DD MMM"),
        //     "DD MMM"
        //   ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        // ) {
        //   arrMonth.push({
        //     date:
        //       moment(dtMonth).format("DD MMM") +
        //       "-" +
        //       moment(deMonth).format("DD MMM"),
        //     add_drop_date: true,
        //     exact_date: important.add_drop_date
        //   });
        // }
        if (
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_recording_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          if (
            moment(
              moment(important.final_recording_date).format("MMM YYYY"),
              "MMM YYYY"
            ).isSame(
              moment(
                moment(important.final_assess_date).format("MMM YYYY"),
                "MMM YYYY"
              )
            )
          ) {
            arrMonth.push({
              date:
                moment(dtMonth).format("DD MMM") +
                "-" +
                moment(deMonth).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
              final_assess_date: true,
              assess_date: important.final_assess_date,
            });
          } else {
            arrMonth.push({
              date:
                moment(dtMonth).format("DD MMM") +
                "-" +
                moment(deMonth).format("DD MMM"),
              final_recording_date: true,
              exact_date: important.final_recording_date,
            });
          }
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            date:
              moment(dtMonth).format("DD MMM") +
              "-" +
              moment(deMonth).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrMonth.push({
            date:
              moment(dtMonth).format("DD MMM") +
              "-" +
              moment(deMonth).format("DD MMM"),
          });
        }
        // arrMonth.push(
        //   moment(dtMonth).format('DD MMM') +
        //     '-' +
        //     moment(deMonth).format('DD MMM'),
        // );
      }
    } else {
      for (
        arrMonth = [],
          dtMonth = new Date(start),
          deMonth = getLastDayOfMonth(
            new Date(start).getFullYear(),
            new Date(start).getMonth()
          );
        dtMonth <= new Date(end);
        dtMonth = getFirstDayOfMonth(
          new Date(dtMonth).getFullYear(),
          new Date(dtMonth).getMonth() + 1
        ),
          deMonth = getLastDayOfMonth(
            new Date(deMonth).getFullYear(),
            new Date(deMonth).getMonth() + 1
          )
      ) {
        if (
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            date:
              moment(dtMonth).format("DD MMM") +
              "-" +
              moment(deMonth).format("DD MMM"),
            add_drop_date: true,
            exact_date: important.add_drop_date,
          });
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            date:
              moment(dtMonth).format("DD MMM") +
              "-" +
              moment(deMonth).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrMonth.push({
            date:
              moment(dtMonth).format("DD MMM") +
              "-" +
              moment(deMonth).format("DD MMM"),
          });
        }
        // arrMonth.push(
        //   moment(dtMonth).format('DD MMM') +
        //     '-' +
        //     moment(deMonth).format('DD MMM'),
        // );
      }
    }
    return arrMonth;
  }

  return empty;
};
function getFirstDayOfMonth(year: number | any, month: number | any) {
  return new Date(year, month, 1);
}
function getLastDayOfMonth(year: number | any, month: number | any) {
  return new Date(year, month + 1, 0);
}
export const generateRoadmapDates = (
  start: any,
  end: any,
  view: "week" | "month",
  lengthNumber: number,
  important: { add_drop_date: string; final_assess_date: string }
) => {
  var empty: string[] = [];
  if (view === "week") {
    var arrWeek, dt, de, counter;
    if (dateDiffWeeks(start, end, "week") < lengthNumber) {
      for (
        counter = 0,
          arrWeek = [],
          dt = new Date(start),
          de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
        counter < lengthNumber;
        counter++, dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
      ) {
        if (
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
            add_drop_date: true,
            exact_date: important.add_drop_date,
          });
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
          });
        }
      }
    } else {
      for (
        arrWeek = [],
          dt = new Date(start),
          de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
      ) {
        if (
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
            add_drop_date: true,
            exact_date: important.add_drop_date,
          });
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dt).format("DD MMM"), "DD MMM"),
            moment(moment(de).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dt).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(de).format("DD MMM"), "DD MMM"))
        ) {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrWeek.push({
            start: moment(dt).format("DD MMM"),
            end: moment(de).format("DD MMM"),
          });
        }
        // arrWeek.push({
        //   start: moment(dt).format('DD MMM'),
        //   end: moment(de).format('DD MMM'),
        // });
      }
    }
    return arrWeek;
  } else if (view === "month") {
    var arrMonth, dtMonth, deMonth, counterMonth;
    if (dateDiffWeeks(start, end, "month") < lengthNumber) {
      for (
        counterMonth = 0,
          arrMonth = [],
          dtMonth = new Date(start),
          deMonth = getLastDayOfMonth(
            new Date(start).getFullYear(),
            new Date(start).getMonth()
          );
        counterMonth < lengthNumber;
        counterMonth++,
          dtMonth = getFirstDayOfMonth(
            new Date(dtMonth).getFullYear(),
            new Date(dtMonth).getMonth() + 1
          ),
          deMonth = getLastDayOfMonth(
            new Date(deMonth).getFullYear(),
            new Date(deMonth).getMonth() + 1
          )
      ) {
        if (
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
            add_drop_date: true,
            exact_date: important.add_drop_date,
          });
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
          });
        }
        // arrMonth.push({
        //   start: moment(dtMonth).format('DD MMM'),
        //   end: moment(deMonth).format('DD MMM'),
        // });
      }
    } else {
      for (
        arrMonth = [],
          dtMonth = new Date(start),
          deMonth = getLastDayOfMonth(
            new Date(start).getFullYear(),
            new Date(start).getMonth()
          );
        dtMonth <= new Date(end);
        dtMonth = getFirstDayOfMonth(
          new Date(dtMonth).getFullYear(),
          new Date(dtMonth).getMonth() + 1
        ),
          deMonth = getLastDayOfMonth(
            new Date(deMonth).getFullYear(),
            new Date(deMonth).getMonth() + 1
          )
      ) {
        if (
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.add_drop_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
            add_drop_date: true,
            exact_date: important.add_drop_date,
          });
        } else if (
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isBetween(
            moment(moment(dtMonth).format("DD MMM"), "DD MMM"),
            moment(moment(deMonth).format("DD MMM"), "DD MMM")
          ) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(dtMonth).format("DD MMM"), "DD MMM")) ||
          moment(
            moment(important.final_assess_date).format("DD MMM"),
            "DD MMM"
          ).isSame(moment(moment(deMonth).format("DD MMM"), "DD MMM"))
        ) {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
            final_assess_date: true,
            exact_date: important.final_assess_date,
          });
        } else {
          arrMonth.push({
            start: moment(dtMonth).format("DD MMM"),
            end: moment(deMonth).format("DD MMM"),
          });
        }
        // arrMonth.push({
        //   start: moment(deMonth).format('DD MMM'),
        //   end: moment(deMonth).format('DD MMM'),
        // });
      }
    }
    return arrMonth;
  }

  return empty;
  // for (
  //   var arr = [],
  //     dt = new Date(start),
  //     de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
  //   dt <= new Date(end);
  //   dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
  // ) {
  //   arr.push({
  //     start: moment(dt).format('DD MMM'),
  //     end: moment(de).format('DD MMM'),
  //   });
  // }
  // return arr;
};
export const generateSampleTimeLineDates = (
  start: any,
  end: any,
  view: "week" | "month"
) => {
  // for (
  //   var arr = [],
  //     dt = new Date(start),
  //     de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
  //   dt <= new Date(end);
  //   dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
  // ) {
  //   arr.push(moment(dt).format('DD MMM') + '-' + moment(de).format('DD MMM'));
  // }
  // return arr;
  var empty: string[] = [];
  if (view === "week") {
    for (
      var arrWeek = [],
        dt = new Date(start),
        de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
    ) {
      arrWeek.push(
        moment(dt).format("DD MMM") + "-" + moment(de).format("DD MMM")
      );
    }
    return arrWeek;
  } else if (view === "month") {
    var arrMonth, dtMonth, deMonth, counter;
    if (dateDiffWeeks(start, end, "month") <= 7) {
      for (
        counter = 0,
          arrMonth = [],
          dtMonth = new Date(start),
          deMonth = new Date(
            new Date(start).setDate(new Date(start).getDate() + 30)
          );
        counter <= 7;
        counter++,
          dtMonth.setDate(dtMonth.getDate() + 31),
          deMonth.setDate(deMonth.getDate() + 31)
      ) {
        arrMonth.push(
          moment(dtMonth).format("DD MMM") +
            "-" +
            moment(deMonth).format("DD MMM")
        );
      }
    } else {
      for (
        arrMonth = [],
          dtMonth = new Date(start),
          deMonth = new Date(
            new Date(start).setDate(new Date(start).getDate() + 30)
          );
        dtMonth <= new Date(end);
        dtMonth.setDate(dtMonth.getDate() + 31),
          deMonth.setDate(deMonth.getDate() + 31)
      ) {
        arrMonth.push(
          moment(dtMonth).format("DD MMM") +
            "-" +
            moment(deMonth).format("DD MMM")
        );
      }
    }
    return arrMonth;
  }
  return empty;
};
export const generateHeaderwidth = (count: any) => {
  const height = count * 68;
  if (height === 0) {
    return "30vh";
  }
  return height + "px";
};

export const generateSampleDates = (start: any, end: any) => {
  for (
    var arr = [],
      dt = new Date(start),
      de = new Date(new Date(start).setDate(new Date(start).getDate() + 6));
    dt <= new Date(end);
    dt.setDate(dt.getDate() + 7), de.setDate(de.getDate() + 7)
  ) {
    arr.push({
      start: moment(dt).format("DD MMM"),
      end: moment(de).format("DD MMM"),
    });
  }
  return arr;
};
export const generateCalendarDates = (start: any, end: any) => {
  var startDate = new Date(start);
  var endDate = new Date(end);
  for (
    var arr = [], dt = startDate;
    dt <= endDate;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(moment(dt).format("DD MMM"));
  }
  return arr;
};
const calculateLeft = (status: any, order: any) => {
  const left = 6 + order * 65;
  return left + "px";
};
const calculateOptioalLeft = (order: any, requiredLength: number) => {
  let left = 0;
  if (requiredLength === 0) {
    left = 246 + order * 65;
  } else {
    left = 15 + order * 65;
  }
  return left + "px";
};
const calculateLeftRoad = (
  start: any,
  actualStart: any,
  view: "week" | "month"
) => {
  const days = dateDiffWeeks(start, actualStart, view);
  if (!Number.isFinite(days)) {
    return "0px";
  }
  const left = 295 * days;
  return left + "px";
};
const calculateTop = (
  firstDate: any,
  activityDate: any,
  status: any,
  view: "week" | "month"
) => {
  const days = dateDiffWeeks(firstDate, activityDate, view);
  if (!Number.isFinite(days)) {
    return 93 + "px";
  }
  const top = days * 157;
  return top + 93 + "px";
};
const calculateHeight = (
  status: any,
  start: any,
  end: any,
  view: "week" | "month"
) => {
  let days = dateDiffWeeks(start, end, view);
  if (!Number.isFinite(days) || days <= 0) {
    return MIN_EVENT_BAR_WIDTH_PX + "px";
  }
  days = Math.abs(days);
  const height = Math.max(MIN_EVENT_BAR_WIDTH_PX, days * 150);
  return height + "px";
};
const calculateEventHeight = (start: any, end: any, view: "week" | "month") => {
  const days = dateDiffWeeks(start, end, view);
  const height = days * 200;
  return height + "px";
};
const dateDiffDays = (date1S: any, date2S: any) => {
  var date1 = new Date(date1S);
  var date2 = new Date(date2S);

  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
};
export const calculateWidth = (
  start: any,
  endDate: any,
  view: "week" | "month"
) => {
  const days = dateDiffWeeks(start, endDate, view);
  const left = 295 * days;
  return left + 500 + "px";
};
function groupBy(xs: Array<any>, key: string) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
export const generateRoadmap = (
  milestones: Array<any>,
  firstDate: any,
  view: "month" | "week"
) => {
  // var dateOffset = 24 * 60 * 60 * 1000 * 5; //5 days
  var startDate = new Date(firstDate);
  // startDate.setTime(startDate.getTime() - dateOffset);
  const calArr: Array<any> = [];
  // const overlaps: Array<any> = [];
  const notOverlaps: Array<any> = [];
  milestones.forEach((miles, index) => {
    const layout = resolveLayoutDateRange(
      miles.start_date,
      miles.target_completion_date,
      startDate
    );
    calArr.push({
      ...miles,
      left: calculateLeftRoad(startDate, layout.start, view),
    });
  });
  let reorderOverlaps = groupBy(calArr, "start_date");
  Object.entries(reorderOverlaps).forEach((entry) => {
    const [key, value] = entry;
    if ((value as Array<any>).length > 1) {
      (value as Array<any>).forEach((element, index) => {
        const left = element.left.split("px")[0];
        element.left = Number(index * 10) + Number(left) + "px";
        element.top = Number(index * 20) + "px";
        notOverlaps.push(element);
      });
    } else {
      notOverlaps.push((value as Array<any>)[0]);
    }
  });
  return notOverlaps;
};
const generateCalendar = (
  milestones: Array<any>,
  firstDate: any,
  view: "week" | "month"
) => {
  const calArr: Array<CalendarType> = [];
  milestones.forEach((miles, index) => {
    const layout = resolveLayoutDateRange(
      miles.start_date,
      miles.target_completion_date,
      firstDate
    );
    calArr.push({
      ...miles,
      title: miles.competency_card.title,
      description: miles.description,
      startDate: formatMilestoneDateDisplay(miles.start_date),
      endDate: formatMilestoneDateDisplay(miles.target_completion_date),
      backgroundColor: resolveEventBackground(miles.graphics),
      fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
      top: calculateLeft("required", index),
      left: calculateTop(firstDate, layout.start, "required", view),
      height: calculateHeight(
        "required",
        layout.start,
        layout.end,
        view
      ),
    });
  });
  return calArr;
};
export const generateRecommendCalendar = (
  milestones: Array<any>,
  firstDate: any,
  view: "week" | "month"
) => {
  const calArr: Array<CalendarType> = [];
  milestones.forEach((miles, index) => {
    const layout = resolveLayoutDateRange(
      miles.start_date,
      miles.target_completion_date,
      firstDate
    );
    if (!miles.isMulti) {
      calArr.push({
        ...miles,
        title: miles.competency_title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateLeft("required", index),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        isMulti: miles.isMulti,
      });
    } else {
      let multiArray: {
        title: any;
        description: any;
        startDate: string;
        endDate: string;
        backgroundColor: any;
        fontColor: string;
        height: string;
      }[] = [];
      miles?.children?.forEach((child: any) => {
        const childLayout = resolveLayoutDateRange(
          child.start_date,
          child.target_completion_date,
          firstDate
        );
        multiArray.push({
          ...child,
          title: child.title,
          description: child.description,
          startDate: formatMilestoneDateDisplay(child.start_date),
          endDate: formatMilestoneDateDisplay(child.target_completion_date),
          backgroundColor: resolveEventBackground(child.graphics),
          fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
          height: calculateHeight(
            "required",
            childLayout.start,
            childLayout.end,
            view
          ),
        });
      });
      calArr.push({
        ...miles,
        title: miles.title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateLeft("required", index),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        children: multiArray,
        isMulti: miles.isMulti,
      });
    }
  });
  return calArr;
};
export const generateOptionalCalendar = (
  milestones: Array<any>,
  firstDate: any,
  reqLength: any,
  view: "week" | "month"
) => {
  const calArr: Array<CalendarType> = [];
  milestones.forEach((miles, index) => {
    const layout = resolveLayoutDateRange(
      miles.start_date,
      miles.target_completion_date,
      firstDate
    );
    if (!miles.isMulti) {
      calArr.push({
        ...miles,
        title: miles.competency_card.title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateOptioalLeft(
          reqLength === 0 ? index + 1 : index + reqLength,
          reqLength
        ),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        isMulti: miles.isMulti,
      });
    } else {
      let multiArray: {
        title: any;
        description: any;
        startDate: string;
        endDate: string;
        backgroundColor: any;
        fontColor: string;
        height: string;
      }[] = [];
      miles.children.forEach((child: any) => {
        const childLayout = resolveLayoutDateRange(
          child.start_date,
          child.target_completion_date,
          firstDate
        );
        multiArray.push({
          ...child,
          title: child.title,
          description: child.description,
          startDate: formatMilestoneDateDisplay(child.start_date),
          endDate: formatMilestoneDateDisplay(child.target_completion_date),
          backgroundColor: resolveEventBackground(child.graphics),
          fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
          height: calculateHeight(
            "required",
            childLayout.start,
            childLayout.end,
            view
          ),
        });
      });
      calArr.push({
        ...miles,
        title: miles.title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateOptioalLeft(
          reqLength === 0 ? index + 1 : index + reqLength,
          reqLength
        ),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        children: multiArray,
        isMulti: miles.isMulti,
      });
    }
  });
  return calArr;
};
export const generateOptionalCalendarRecommmend = (
  milestones: Array<any>,
  firstDate: any,
  reqLength: any,
  view: "week" | "month"
) => {
  const calArr: Array<CalendarType> = [];
  milestones.forEach((miles, index) => {
    const layout = resolveLayoutDateRange(
      miles.start_date,
      miles.target_completion_date,
      firstDate
    );
    if (!miles.isMulti) {
      calArr.push({
        ...miles,
        title: miles.competency_title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateOptioalLeft(
          reqLength === 0 ? index + 1 : index + reqLength,
          reqLength
        ),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        isMulti: miles.isMulti,
      });
    } else {
      let multiArray: {
        title: any;
        description: any;
        startDate: string;
        endDate: string;
        backgroundColor: any;
        fontColor: string;
        height: string;
      }[] = [];
      miles?.children?.forEach((child: any) => {
        const childLayout = resolveLayoutDateRange(
          child.start_date,
          child.target_completion_date,
          firstDate
        );
        multiArray.push({
          ...child,
          title: child.competency_title,
          description: child.description,
          startDate: formatMilestoneDateDisplay(child.start_date),
          endDate: formatMilestoneDateDisplay(child.target_completion_date),
          backgroundColor: resolveEventBackground(child.graphics),
          fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
          height: calculateHeight(
            "required",
            childLayout.start,
            childLayout.end,
            view
          ),
        });
      });
      calArr.push({
        ...miles,
        title: miles.title,
        description: miles.description,
        startDate: formatMilestoneDateDisplay(miles.start_date),
        endDate: formatMilestoneDateDisplay(miles.target_completion_date),
        backgroundColor: resolveEventBackground(miles.graphics),
        fontColor: DEFAULT_GRAPHICS_FONT_COLOR,
        top: calculateOptioalLeft(
          reqLength === 0 ? index + 1 : index + reqLength,
          reqLength
        ),
        left: calculateTop(firstDate, layout.start, "required", view),
        height: calculateHeight(
          "required",
          layout.start,
          layout.end,
          view
        ),
        children: multiArray,
        isMulti: miles.isMulti,
      });
    }
  });
  return calArr;
};

export default generateCalendar;
